(function() {
  'use strict';

  var config = window.MultiLikesConfig || {};
  var strings = config.strings || {};
  var wishlistVariantIds = new Set(Array.isArray(config.wishlistVariantIds) ? config.wishlistVariantIds.map(String) : []);
  var productRequests = new Map();
  var resolveRequests = new Map();
  var variantModal = null;
  var loginModal = null;
  var loginModalCloseTimer = null;
  var activeVariantSource = null;
  var activeVariantProductData = null;
  var activeVariantHandle = '';
  var modalSelectionToken = 0;
  var wishlistPriceRanges = {
    'under-1000': { min: null, max: 1000 },
    '1000-3000': { min: 1000, max: 3000 },
    '3000-5000': { min: 3000, max: 5000 },
    '5000-10000': { min: 5000, max: 10000 },
    '10000-20000': { min: 10000, max: 20000 },
    '20000-50000': { min: 20000, max: 50000 },
    'over-50000': { min: 50000, max: null }
  };

  if (!config.endpoint) {
    return;
  }

  // 状態の判定はレイアウトが埋め込む wishlistVariantIds だけが頼り。無いと全ボタンが未登録に見える
  if (config.customerId && !Array.isArray(config.wishlistVariantIds)) {
    console.warn('MultiLikes: wishlistVariantIds is missing, so every button shows as not in the wishlist.');
  }

  function setWishlisted(variantId, isInWishlist) {
    if (isInWishlist) {
      wishlistVariantIds.add(String(variantId));
    } else {
      wishlistVariantIds.delete(String(variantId));
    }
  }

  // 追加・解除の結果を、しばらく手元にも残して埋め込み値より優先する。
  // 戻る操作でキャッシュのページが出たときや、直後に開いたページの Liquid がまだ古い値を出したときのため。
  // 引き換えに、ほかの端末での変更はこの間だけ隠れる。
  var RECENT_CHANGES_KEY = 'multilikes:recent-changes';
  var RECENT_CHANGES_TTL = 10 * 60 * 1000;

  function storeRecentChanges(changes) {
    try {
      if (Object.keys(changes).length) {
        window.localStorage.setItem(RECENT_CHANGES_KEY, JSON.stringify({ customerId: config.customerId, changes: changes }));
      } else {
        window.localStorage.removeItem(RECENT_CHANGES_KEY);
      }
    } catch (error) {
      // 保存できなくても、表示は埋め込み値で続ける
    }
  }

  // ログイン中のお客様の、期限内の記録だけを返す
  function readRecentChanges() {
    var stored = null;
    var changes = {};
    var now = Date.now();

    try {
      stored = JSON.parse(window.localStorage.getItem(RECENT_CHANGES_KEY));
    } catch (error) {
      stored = null;
    }
    if (!stored || !stored.changes || stored.customerId !== config.customerId) {
      return changes;
    }

    Object.keys(stored.changes).forEach(function(variantId) {
      var change = stored.changes[variantId];
      var age = change ? now - change.at : NaN;
      // 端末の時計が戻されると未来の時刻が残り続けるので、負の経過時間も期限切れにする
      if (age >= 0 && age < RECENT_CHANGES_TTL) {
        changes[variantId] = change;
      }
    });
    return changes;
  }

  function rememberChange(variantId, isInWishlist) {
    var changes = readRecentChanges();
    changes[variantId] = { inWishlist: isInWishlist, at: Date.now() };
    storeRecentChanges(changes);
  }

  function applyRecentChanges() {
    var changes = readRecentChanges();
    Object.keys(changes).forEach(function(variantId) {
      setWishlisted(variantId, changes[variantId].inWishlist);
    });
    // 期限切れと、ほかのお客様の記録はここで消える
    storeRecentChanges(changes);
  }

  if (config.customerId) {
    applyRecentChanges();
  } else {
    // ログアウトしたら、前のお客様の記録を端末に残さない
    storeRecentChanges({});
  }

  function request(method, params) {
    var url = new URL(config.endpoint, window.location.origin);
    var options = {
      method: method,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    };

    if (method === 'GET') {
      Object.keys(params).forEach(function(key) {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          url.searchParams.set(key, params[key]);
        }
      });
    } else {
      options.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
      options.body = new URLSearchParams(params).toString();
    }

    return fetch(url.toString(), options)
      .then(function(response) {
        if (!response.ok) {
          throw new Error('MultiLikes request failed: ' + response.status);
        }
        return response.json();
      })
      .then(function(payload) {
        if (payload.error) {
          throw new Error(payload.error);
        }
        return payload;
      });
  }

  var api = {
    updateProduct: function(action, productId, variantId) {
      return request('POST', {
        target_type: 'product',
        customer_id: config.customerId,
        action: action,
        product_id: productId,
        variant_id: variantId
      });
    },

    getCustomerWishlist: function(customerId, limit, after) {
      return request('GET', {
        target_type: 'product',
        mode: 'customer_wishlist',
        customer_id: customerId,
        limit: limit,
        after: after
      });
    }
  };

  function announce(message) {
    var region = document.querySelector('[data-multilikes-status]');
    if (region) {
      region.textContent = '';
      window.setTimeout(function() {
        region.textContent = message;
      }, 20);
    }
  }

  function setButtonLoading(button, isLoading) {
    button.classList.toggle('is-loading', isLoading);
    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function setButtonState(button, isInWishlist) {
    var label = button.querySelector('[data-multilikes-button-label]');
    var text = isInWishlist
      ? (button.dataset.multilikesRemoveLabel || strings.remove)
      : (button.dataset.multilikesAddLabel || strings.add);

    button.classList.toggle('is-active', isInWishlist);
    button.setAttribute('aria-pressed', isInWishlist ? 'true' : 'false');
    button.setAttribute('aria-label', text);
    if (label) {
      label.textContent = text;
    }
  }

  function updateMatchingButtons(productId, variantId, isInWishlist) {
    document.querySelectorAll('.js-multilikes-toggle').forEach(function(button) {
      if (button.dataset.multilikesProductId === String(productId) && button.dataset.multilikesVariantId === String(variantId)) {
        setButtonState(button, isInWishlist);
      }
    });
  }

  // 登録状態はアプリに問い合わせず、埋め込まれた顧客メタフィールドの値で判定する。
  // ボタンごとに問い合わせると、大型販売の日にアプリのサーバーが溢れる（2026-10-01 障害）。
  function applyButtonState(button) {
    var variantId = button.dataset.multilikesVariantId;
    setButtonState(button, Boolean(config.customerId && variantId && wishlistVariantIds.has(variantId)));
  }

  function applyAllButtonStates(root) {
    (root || document).querySelectorAll('.js-multilikes-toggle').forEach(function(button) {
      if (button.dataset.multilikesContext !== 'wishlist' && button.dataset.multilikesContext !== 'variant-modal') {
        applyButtonState(button);
      }
    });
  }

  function handleLoginModalKeydown(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      closeLoginModal();
    }
  }

  function closeLoginModal() {
    if (!loginModal || !loginModal.classList.contains('is-open')) {
      return;
    }

    loginModal.classList.remove('is-open');
    loginModal.classList.add('is-closing');
    document.documentElement.classList.remove('multilikes-login-modal-open');
    document.removeEventListener('keydown', handleLoginModalKeydown);

    window.clearTimeout(loginModalCloseTimer);
    loginModalCloseTimer = window.setTimeout(function() {
      loginModal.classList.remove('is-closing');
      loginModal.hidden = true;
    }, 500); // matches the theme's modal close transition
  }

  function openLoginModal() {
    if (!loginModal) {
      return false;
    }

    window.clearTimeout(loginModalCloseTimer);
    loginModal.classList.remove('is-closing');
    loginModal.hidden = false;
    loginModal.classList.add('is-open');
    document.documentElement.classList.add('multilikes-login-modal-open');
    document.addEventListener('keydown', handleLoginModalKeydown);

    var focusTarget = loginModal.querySelector('[data-multilikes-login-link]');
    if (focusTarget) {
      focusTarget.focus();
    }

    return true;
  }

  function initializeLoginModal() {
    if (config.customerId) {
      return;
    }

    loginModal = document.querySelector('[data-multilikes-login-modal]');
    if (!loginModal) {
      return;
    }

    var loginLink = loginModal.querySelector('[data-multilikes-login-link]');
    if (loginLink && config.loginUrl) {
      var loginUrl = new URL(config.loginUrl, window.location.origin);
      loginUrl.searchParams.set('return_url', window.location.pathname + window.location.search);
      loginLink.href = loginUrl.pathname + loginUrl.search;
    }

    loginModal.addEventListener('click', function(event) {
      if (event.target.closest('[data-multilikes-login-close]')) {
        closeLoginModal();
      }
    });
  }

  function initializeVariantModal() {
    if (!config.customerId || !document.getElementById('MultiLikesVariantModal')) {
      return;
    }

    if (window.theme && theme.Modals) {
      variantModal = new theme.Modals('MultiLikesVariantModal', 'multilikes-variant');
      document.addEventListener('modalClose.MultiLikesVariantModal', function() {
        if (activeVariantSource) {
          activeVariantSource.setAttribute('aria-expanded', 'false');
          activeVariantSource = null;
        }
      });
    }
  }

  function getButtonVariantData(button) {
    var productScope = button.closest('.grid-product') || button.parentElement;
    var variantsJson = productScope && productScope.querySelector('[data-multilikes-variants]');

    if (!variantsJson) {
      return null;
    }

    try {
      return JSON.parse(variantsJson.textContent);
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  function updateVariantModalSelection(actionButton, variantId) {
    actionButton.dataset.multilikesVariantId = String(variantId);
    applyButtonState(actionButton);
  }

  function findVariantById(variants, variantId) {
    return variants.find(function(variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function findVariantByOptions(variants, values) {
    var key = JSON.stringify(values);
    return variants.find(function(variant) {
      return JSON.stringify(variant.options) === key;
    });
  }

  function optionValueNames(productOption) {
    return productOption.values.map(function(optionValue) {
      return optionValue.name;
    });
  }

  function optionValueIds(productData, values) {
    return productData.options.map(function(productOption, index) {
      var match = productOption.values.find(function(optionValue) {
        return optionValue.name === values[index];
      });
      return match ? match.id : '';
    });
  }

  function combinationsOf(valueLists) {
    return valueLists.reduce(function(rows, values) {
      var expanded = [];
      rows.forEach(function(row) {
        values.forEach(function(value) {
          expanded.push(row.concat([value]));
        });
      });
      return expanded;
    }, [[]]);
  }

  function withoutIndex(values, index) {
    return values.filter(function(value, valueIndex) {
      return valueIndex !== index;
    });
  }

  function withValueAt(values, index, value) {
    var combined = values.slice();
    combined.splice(index, 0, value);
    return combined;
  }

  // product.variants が 250 件で打ち切られている商品向け。
  // 選択された組み合わせを Section Rendering API でサーバーに解決させる。
  function resolveVariantFromServer(productData, handle, values) {
    var valueIds = optionValueIds(productData, values);
    var hasAllIds = valueIds.every(function(valueId) {
      return Boolean(valueId);
    });

    if (!handle || !hasAllIds) {
      return Promise.resolve(null);
    }

    var requestKey = handle + ':' + valueIds.join(',');
    if (resolveRequests.has(requestKey)) {
      return resolveRequests.get(requestKey);
    }

    var rootUrl = config.rootUrl || '/';
    var resolverUrl = rootUrl.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) +
      '?section_id=multilikes-variant-resolver&option_values=' + valueIds.join(',');

    var resolveRequest = fetch(resolverUrl, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('MultiLikes variant lookup failed: ' + response.status);
        }
        return response.text();
      })
      .then(function(html) {
        var payload = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-multilikes-resolved-variant]');
        // パスワードページなど、解決用の要素が無い応答は失敗として扱う（キャッシュしない）
        if (!payload) {
          throw new Error('MultiLikes variant lookup returned no resolver payload');
        }
        var variant = JSON.parse(payload.textContent);

        // 組み合わせが存在しないとサーバーは別のバリエーションを返すため、必ず照合する
        if (!variant || JSON.stringify(variant.options) !== JSON.stringify(values)) {
          return null;
        }
        return variant;
      })
      .catch(function(error) {
        console.error(error);
        // 通信の失敗は覚えない。覚えると、実在する組み合わせがリロードまで選べなくなる
        resolveRequests.delete(requestKey);
        return null;
      });

    resolveRequests.set(requestKey, resolveRequest);
    return resolveRequest;
  }

  function selectModalVariant(modal, variant) {
    var actionButton = modal.querySelector('.js-multilikes-toggle');
    // サーバー解決待ちの loading はここで外す。追加・解除の送信中なら loading のまま押せなくしておく
    setButtonLoading(actionButton, isSending(actionButton));
    updateVariantModalSelection(actionButton, variant.id);
  }

  function resetModalVariant(modal) {
    var actionButton = modal.querySelector('.js-multilikes-toggle');
    delete actionButton.dataset.multilikesVariantId;
    setButtonState(actionButton, false);
    actionButton.classList.remove('is-loading');
    actionButton.setAttribute('aria-busy', 'false');
    actionButton.disabled = true;
  }

  function createVariantOption(inputName, value, labelText, checked) {
    var row = document.createElement('div');
    var label = document.createElement('label');
    var input = document.createElement('input');
    var name = document.createElement('span');
    var status = document.createElement('span');

    row.className = 'multilikes-variant-modal__option';
    input.type = 'radio';
    input.name = inputName;
    input.value = value;
    input.checked = Boolean(checked);
    name.className = 'multilikes-variant-modal__option-name';
    name.textContent = labelText;
    status.className = 'multilikes-variant-modal__option-status';

    label.appendChild(input);
    label.appendChild(name);
    label.appendChild(status);
    row.appendChild(label);

    return {
      row: row,
      input: input,
      status: status
    };
  }

  function optionElementsFromInput(input) {
    var row = input.closest('.multilikes-variant-modal__option');
    return {
      row: row,
      input: input,
      status: row.querySelector('.multilikes-variant-modal__option-status')
    };
  }

  function setVariantOptionState(optionElements, variant, productData, showUnavailable) {
    if (variant) {
      optionElements.input.disabled = false;
      optionElements.row.classList.remove('is-unavailable');
      optionElements.status.textContent = variant.available ? '' : strings.soldOut;
      return;
    }

    // 埋め込み一覧が打ち切られている商品は、ローカルに無いだけの可能性がある。
    // 選択された時点でサーバーに問い合わせるので、ここでは選べる状態のままにする。
    if (productData && productData.truncated) {
      optionElements.input.disabled = false;
      optionElements.row.classList.remove('is-unavailable');
      optionElements.status.textContent = '';
      return;
    }

    optionElements.input.disabled = true;
    optionElements.row.classList.add('is-unavailable');
    optionElements.status.textContent = showUnavailable ? strings.unavailable : '';
  }

  function createVariantOptionList() {
    var list = document.createElement('div');
    list.className = 'multilikes-variant-modal__option-list';
    return list;
  }

  // モーダルに並べる行。打ち切られていない商品は実在するバリエーションだけを出し、
  // 打ち切られている商品はオプション値の全組み合わせから組み立てる。
  function variantRows(productData) {
    if (!productData.truncated) {
      return productData.variants.map(function(variant) {
        return { values: variant.options, variant: variant };
      });
    }

    return combinationsOf(productData.options.map(optionValueNames)).map(function(values) {
      return { values: values, variant: findVariantByOptions(productData.variants, values) };
    });
  }

  function renderAllVariants(modal, productData, selectedVariant) {
    var options = modal.querySelector('[data-multilikes-variant-options]');
    var list = createVariantOptionList();
    var selectedValues = selectedVariant ? JSON.stringify(selectedVariant.options) : '';
    options.innerHTML = '';

    variantRows(productData).forEach(function(row, index) {
      var optionElements = createVariantOption(
        'multilikes-variant',
        String(index),
        row.variant ? row.variant.title : row.values.join(' / '),
        JSON.stringify(row.values) === selectedValues
      );
      optionElements.input.dataset.multilikesOptionValues = JSON.stringify(row.values);
      setVariantOptionState(optionElements, row.variant, productData, true);
      list.appendChild(optionElements.row);
    });

    options.appendChild(list);

    if (selectedVariant) {
      selectModalVariant(modal, selectedVariant);
    } else {
      resetModalVariant(modal);
    }
  }

  function getPlayerOptionIndex(productData) {
    if (productData.options.length < 2) {
      return -1;
    }

    return productData.options.findIndex(function(productOption) {
      return productOption.name.indexOf('選手名') !== -1;
    });
  }

  function getNonPlayerCombinations(productData, playerOptionIndex) {
    if (productData.truncated) {
      return combinationsOf(
        withoutIndex(productData.options, playerOptionIndex).map(optionValueNames)
      );
    }

    var combinations = new Map();

    productData.variants.forEach(function(variant) {
      var values = withoutIndex(variant.options, playerOptionIndex);
      var key = JSON.stringify(values);
      if (!combinations.has(key)) {
        combinations.set(key, values);
      }
    });

    return Array.from(combinations.values());
  }

  function updatePlayerVariantOptions(modal) {
    var playerSelect = modal.querySelector('[data-multilikes-player-option]');
    var playerName = playerSelect.value;
    var productData = activeVariantProductData;
    var playerOptionIndex = Number(playerSelect.dataset.multilikesPlayerOption);

    modal.querySelectorAll('[data-multilikes-option-values]').forEach(function(input) {
      var combination = JSON.parse(input.dataset.multilikesOptionValues);
      var variant = playerName
        ? findVariantByOptions(productData.variants, withValueAt(combination, playerOptionIndex, playerName))
        : null;
      setVariantOptionState(optionElementsFromInput(input), variant, playerName ? productData : null, Boolean(playerName));
      input.checked = false;
    });

    modalSelectionToken += 1;
    resetModalVariant(modal);
  }

  function renderPlayerGroupedVariants(modal, productData, playerOptionIndex, selectedVariant) {
    var options = modal.querySelector('[data-multilikes-variant-options]');
    var playerOption = productData.options[playerOptionIndex];
    var field = document.createElement('div');
    var label = document.createElement('label');
    var select = document.createElement('select');
    var placeholder = document.createElement('option');
    var listLabel = document.createElement('span');
    var list = createVariantOptionList();
    var combinations = getNonPlayerCombinations(productData, playerOptionIndex);
    var nonPlayerOptionNames = withoutIndex(productData.options, playerOptionIndex).map(function(productOption) {
      return productOption.name;
    });
    var selectedPlayerName = selectedVariant ? selectedVariant.options[playerOptionIndex] : '';
    var selectedCombination = selectedVariant
      ? JSON.stringify(withoutIndex(selectedVariant.options, playerOptionIndex))
      : '';

    options.innerHTML = '';
    field.className = 'multilikes-variant-modal__field';
    label.htmlFor = 'MultiLikesPlayerOption';
    label.textContent = playerOption.name;
    select.id = 'MultiLikesPlayerOption';
    select.dataset.multilikesPlayerOption = String(playerOptionIndex);
    placeholder.value = '';
    placeholder.textContent = strings.playerPlaceholder;
    placeholder.selected = !selectedPlayerName;
    select.appendChild(placeholder);

    optionValueNames(playerOption).forEach(function(value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      option.selected = value === selectedPlayerName;
      select.appendChild(option);
    });

    field.appendChild(label);
    field.appendChild(select);
    options.appendChild(field);

    listLabel.className = 'multilikes-variant-modal__list-label';
    listLabel.textContent = nonPlayerOptionNames.join(' / ');
    options.appendChild(listLabel);
    options.appendChild(list);

    combinations.forEach(function(combination, index) {
      var variant = selectedPlayerName
        ? findVariantByOptions(productData.variants, withValueAt(combination, playerOptionIndex, selectedPlayerName))
        : null;
      var optionElements = createVariantOption(
        'multilikes-variant-combination',
        String(index),
        combination.join(' / '),
        JSON.stringify(combination) === selectedCombination
      );
      optionElements.input.dataset.multilikesOptionValues = JSON.stringify(combination);
      setVariantOptionState(optionElements, variant, selectedPlayerName ? productData : null, Boolean(selectedPlayerName));
      list.appendChild(optionElements.row);
    });

    if (selectedVariant) {
      selectModalVariant(modal, selectedVariant);
    } else {
      resetModalVariant(modal);
    }
  }

  // モーダル上で選ばれているオプション値を、商品のオプション順に並べて返す
  function modalSelectedValues(modal) {
    var checked = modal.querySelector('[data-multilikes-option-values]:checked');
    if (!checked) {
      return null;
    }

    var values = JSON.parse(checked.dataset.multilikesOptionValues);
    var playerSelect = modal.querySelector('[data-multilikes-player-option]');
    if (!playerSelect) {
      return values;
    }
    if (!playerSelect.value) {
      return null;
    }

    return withValueAt(values, Number(playerSelect.dataset.multilikesPlayerOption), playerSelect.value);
  }

  function applyModalSelection(modal) {
    var productData = activeVariantProductData;
    var values = modalSelectedValues(modal);
    // 選択が変わったら、解決待ちの古い結果は捨てる（遅れて届くと選んでいない SKU が入る）
    var token = ++modalSelectionToken;

    if (!productData || !values) {
      resetModalVariant(modal);
      return;
    }

    var variant = findVariantByOptions(productData.variants, values);
    if (variant) {
      selectModalVariant(modal, variant);
      return;
    }

    var checked = modal.querySelector('[data-multilikes-option-values]:checked');

    // 打ち切られていない一覧に無い＝実在しない組み合わせ。別バリエーションを登録しないよう選べなくする
    if (!productData.truncated) {
      setVariantOptionState(optionElementsFromInput(checked), null, null, true);
      checked.checked = false;
      resetModalVariant(modal);
      return;
    }

    var actionButton = modal.querySelector('.js-multilikes-toggle');

    resetModalVariant(modal);
    setButtonLoading(actionButton, true);

    // loading は、選び直し（selectModalVariant）か選べない扱い（resetModalVariant）で外れる
    resolveVariantFromServer(productData, activeVariantHandle, values).then(function(resolved) {
      if (token !== modalSelectionToken) {
        return;
      }

      if (resolved) {
        setVariantOptionState(optionElementsFromInput(checked), resolved, productData, true);
        selectModalVariant(modal, resolved);
        return;
      }

      setVariantOptionState(optionElementsFromInput(checked), null, null, true);
      checked.checked = false;
      resetModalVariant(modal);
    });
  }

  function openVariantModal(button) {
    var modal = document.getElementById('MultiLikesVariantModal');

    if (!variantModal || !modal) {
      handleToggle(button);
      return;
    }

    var hideVariantOptions = button.dataset.multilikesHideVariantOptions === 'true';
    var productData = hideVariantOptions ? null : getButtonVariantData(button);

    if (!hideVariantOptions && (!productData || !productData.options || !productData.variants || productData.variants.length === 0)) {
      handleToggle(button);
      return;
    }

    var optionsFieldset = modal.querySelector('[data-multilikes-variant-options-fieldset]');
    var selectedSkuInfo = modal.querySelector('[data-multilikes-selected-sku]');
    var selectedVariantTitle = modal.querySelector('[data-multilikes-selected-variant-title]');
    var actionButton = modal.querySelector('.js-multilikes-toggle');

    actionButton.dataset.multilikesProductId = String(button.dataset.multilikesProductId);
    actionButton.dataset.multilikesAddLabel = button.dataset.multilikesModalAddLabel || actionButton.dataset.multilikesSkuAddLabel;
    actionButton.dataset.multilikesRemoveLabel = button.dataset.multilikesModalRemoveLabel || actionButton.dataset.multilikesSkuRemoveLabel;
    optionsFieldset.classList.toggle('hide', hideVariantOptions);
    selectedSkuInfo.classList.toggle('hide', !hideVariantOptions);
    activeVariantProductData = productData;
    activeVariantHandle = button.dataset.multilikesProductHandle || '';
    modalSelectionToken += 1;

    if (hideVariantOptions) {
      // PDP は選択中バリエーションをボタン自身が持っている。
      // product.variants は 250 件で打ち切られるため、埋め込み一覧から引き直さない。
      if (!button.dataset.multilikesVariantId) {
        return;
      }

      var variantTitle = button.dataset.multilikesVariantTitle || '';
      if (variantTitle === 'Default Title') {
        variantTitle = '';
      }
      selectedVariantTitle.textContent = [button.dataset.multilikesProductTitle || '', variantTitle].filter(Boolean).join(' - ');
      selectedVariantTitle.classList.toggle('hide', !selectedVariantTitle.textContent);
      selectModalVariant(modal, { id: button.dataset.multilikesVariantId });
    } else {
      selectedVariantTitle.textContent = '';
      selectedVariantTitle.classList.add('hide');

      var selectedVariant = findVariantById(productData.variants, button.dataset.multilikesVariantId) || null;
      var playerOptionIndex = getPlayerOptionIndex(productData);

      if (playerOptionIndex === -1) {
        renderAllVariants(modal, productData, selectedVariant);
      } else {
        renderPlayerGroupedVariants(modal, productData, playerOptionIndex, selectedVariant);
      }
    }

    activeVariantSource = button;
    button.setAttribute('aria-expanded', 'true');
    variantModal.open();
  }

  // 追加・解除の送信中の印。loading の見た目はサーバー解決待ちと共用なので、二重送信の判定はこちらで行う
  function isSending(button) {
    return button.dataset.multilikesSending === 'true';
  }

  function handleToggle(button) {
    var productId = button.dataset.multilikesProductId;
    var variantId = button.dataset.multilikesVariantId;

    // 送信が重なると、アプリはメタフィールドを丸ごと書き戻すので片方が消える。
    // バリエーションが決まっていないモーダルのボタンからも送らない
    if (!config.customerId || !variantId || isSending(button) || button.classList.contains('is-loading')) {
      return Promise.resolve(false);
    }

    var action = button.classList.contains('is-active') ? 'remove' : 'add';

    button.dataset.multilikesSending = 'true';
    setButtonLoading(button, true);
    return api.updateProduct(action, productId, variantId)
      .then(function(payload) {
        var isInWishlist = Boolean(payload.data && payload.data.isInWishlist);
        setWishlisted(variantId, isInWishlist);
        rememberChange(String(variantId), isInWishlist);
        updateMatchingButtons(productId, variantId, isInWishlist);
        announce(isInWishlist ? strings.added : strings.removed);
        document.dispatchEvent(new CustomEvent('multilikes:changed', {
          detail: {
            productId: String(productId),
            variantId: String(variantId),
            isInWishlist: isInWishlist
          }
        }));
        return true;
      })
      .catch(function(error) {
        console.error(error);
        announce(strings.error);
        return false;
      })
      .finally(function() {
        delete button.dataset.multilikesSending;
        setButtonLoading(button, false);
        // 送信中にモーダルで選択が外れていたら、押せないままにする
        if (!button.dataset.multilikesVariantId) {
          button.disabled = true;
        }
      });
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.js-multilikes-toggle');
    if (!button) {
      return;
    }

    if (!config.customerId) {
      event.preventDefault();
      event.stopPropagation();

      if (!openLoginModal()) {
        var loginUrl = new URL(config.loginUrl, window.location.origin);
        loginUrl.searchParams.set('return_url', window.location.pathname + window.location.search);
        window.location.assign(loginUrl.pathname + loginUrl.search);
      }

      return;
    }

    if (config.customerId) {
      event.preventDefault();
      event.stopPropagation();
      if (button.dataset.multilikesUseVariantModal === 'true') {
        openVariantModal(button);
      } else {
        handleToggle(button).then(function(success) {
          if (success && button.dataset.multilikesContext === 'variant-modal' && variantModal) {
            variantModal.close();
          }
        });
      }
    }
  });

  document.addEventListener('change', function(event) {
    if (event.target.matches('[data-multilikes-player-option]')) {
      updatePlayerVariantOptions(event.target.closest('#MultiLikesVariantModal'));
      return;
    }

    if (event.target.matches('[data-multilikes-option-values]')) {
      var modal = event.target.closest('#MultiLikesVariantModal');
      if (modal) {
        applyModalSelection(modal);
      }
    }
  });

  document.addEventListener('variant:change', function(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) {
      return;
    }

    document.querySelectorAll('.multilikes-button--pdp').forEach(function(button) {
      button.dataset.multilikesVariantId = String(variant.id);
      button.dataset.multilikesVariantTitle = variant.title || '';
      applyButtonState(button);
    });
  });

  // おすすめ商品・コレクションの絞り込み・テーマエディタでは、商品カードが後から差し込まれる
  ['recommendations:loaded', 'collection:reloaded', 'shopify:section:load'].forEach(function(eventName) {
    document.addEventListener(eventName, function() {
      applyAllButtonStates(document);
    });
  });

  // 戻る・進むでページがそのまま復元されたときは、ほかのページでの追加・解除を反映する
  window.addEventListener('pageshow', function(event) {
    if (event.persisted && config.customerId) {
      applyRecentChanges();
      applyAllButtonStates(document);
    }
  });

  function productJson(handle) {
    if (!handle) {
      return Promise.resolve(null);
    }
    if (productRequests.has(handle)) {
      return productRequests.get(handle);
    }

    var rootUrl = config.rootUrl || '/';
    var productUrl = rootUrl.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js';
    var productRequest = fetch(productUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Product JSON request failed: ' + response.status);
        }
        return response.json();
      })
      .catch(function(error) {
        console.error(error);
        return null;
      });

    productRequests.set(handle, productRequest);
    return productRequest;
  }

  function playerNameFromTags(tags) {
    if (!Array.isArray(tags)) {
      return '';
    }

    var playerNames = tags.map(function(tag) {
      var match = String(tag).match(/^(?:player|選手)[:_](.+)$/i);
      return match ? match[1].trim() : '';
    }).filter(Boolean).filter(function(value, index, values) {
      return values.indexOf(value) === index;
    });

    return playerNames.length === 1 ? playerNames[0] : '';
  }

  function playerNameFromSku(sku, title) {
    var segments = String(sku || '').split(/[-_\/|]+/).map(function(segment) {
      return segment.trim();
    }).filter(function(segment) {
      return /[一-龠々ぁ-んァ-ヶ]/.test(segment);
    });
    var titleMatches = segments.filter(function(segment) {
      return String(title || '').indexOf(segment) !== -1;
    });

    if (titleMatches.length === 1) {
      return titleMatches[0];
    }
    return segments.length === 1 ? segments[0] : '';
  }

  function optionName(option) {
    return typeof option === 'string' ? option : String(option && option.name || '');
  }

  function formattedPriceAmount(value) {
    if (typeof value === 'number') {
      return value;
    }

    var normalized = String(value || '').replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    var amount = Number(normalized);
    return Number.isFinite(amount) ? amount : 0;
  }

  function imageUrl(image) {
    if (!image) {
      return '';
    }
    if (typeof image === 'string') {
      return image;
    }
    if (image.src) {
      return image.src;
    }
    if (image.preview_image && image.preview_image.src) {
      return image.preview_image.src;
    }
    return '';
  }

  function enrichProductData(item) {
    item.playerName = item.playerName || playerNameFromTags(item.tags);
    item.size = item.size || '';
    item.productType = item.productType || '';
    item.priceAmount = formattedPriceAmount(item.price);
    if (!item.productHandle) {
      return Promise.resolve(item);
    }

    return productJson(item.productHandle).then(function(product) {
      if (!product || !Array.isArray(product.variants)) {
        return item;
      }
      item.productType = item.productType || product.type || product.product_type || '';
      var variant = product.variants.find(function(candidate) {
        return String(candidate.id) === String(item.id);
      });
      if (variant) {
        item.sku = item.sku || variant.sku || '';
        var variantPrice = Number(variant.price);
        if (Number.isFinite(variantPrice)) {
          item.priceAmount = variantPrice / 100;
        }
        var variantImage = imageUrl(variant.featured_image) || imageUrl(variant.featured_media);
        var productImage = imageUrl(product.featured_image) || (Array.isArray(product.images) ? imageUrl(product.images[0]) : '');
        item.image = variantImage || productImage || item.image;

        if (Array.isArray(product.options) && Array.isArray(variant.options)) {
          var playerOptionIndex = product.options.findIndex(function(productOption) {
            return /選手名|player/i.test(optionName(productOption));
          });
          if (playerOptionIndex !== -1 && variant.options[playerOptionIndex]) {
            item.playerName = String(variant.options[playerOptionIndex]);
          }

          var sizeOptionIndex = product.options.findIndex(function(productOption) {
            return /サイズ|size/i.test(optionName(productOption));
          });
          if (sizeOptionIndex !== -1 && variant.options[sizeOptionIndex]) {
            item.size = String(variant.options[sizeOptionIndex]);
          }
        }
        item.playerName = item.playerName || playerNameFromSku(item.sku, item.title);
      }
      return item;
    });
  }

  function productUrl(item) {
    var rootUrl = config.rootUrl || '/';
    var url = rootUrl.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(item.productHandle || '');
    if (item.id) {
      url += '?variant=' + encodeURIComponent(item.id);
    }
    return url;
  }

  function hasRestockTag(item) {
    if (!Array.isArray(item.tags)) {
      return false;
    }
    return item.tags.some(function(tag) {
      var value = String(tag).toLowerCase();
      return value === 'restock' || value.indexOf('再入荷') !== -1;
    });
  }

  function inventoryLabels(item) {
    var labels = [];

    if (hasRestockTag(item)) {
      labels.push({ text: strings.restock, className: 'grid-product__tag--restock' });
    }

    if (item.available === false) {
      labels.push({ text: strings.soldOut, className: 'grid-product__tag--sold-out' });
      return labels;
    }

    var quantity = Number(item.sellableOnlineQuantity);
    var threshold = Number(config.lowStockThreshold || 3);
    if (Number.isFinite(quantity) && quantity > 0 && quantity <= threshold) {
      labels.push({ text: strings.lowStock, className: 'grid-product__tag--sale' });
    }
    return labels;
  }

  function createWishlistButton(item) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'multilikes-button multilikes-button--wishlist js-multilikes-toggle is-active';
    button.dataset.multilikesContext = 'wishlist';
    button.dataset.multilikesProductId = String(item.productId || '');
    button.dataset.multilikesVariantId = String(item.id || '');
    button.setAttribute('aria-pressed', 'true');
    button.setAttribute('aria-label', strings.remove);
    button.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-heart" viewBox="0 0 64 64"><path d="M51.27 15.05a13 13 0 0 0-18.44 0l-.83.83-.83-.83a13 13 0 0 0-18.44 18.44l.83.83L32 52.77l18.44-18.45.83-.83a13 13 0 0 0 0-18.44z"/></svg>';
    return button;
  }

  function createWishlistCard(item) {
    var gridItem = document.createElement('div');
    var content = document.createElement('div');
    var link = document.createElement('a');
    var imageMask = document.createElement('div');
    var imageRatio = document.createElement('div');
    var meta = document.createElement('div');
    var title = document.createElement('div');
    var variantTitle = document.createElement('div');
    var price = document.createElement('div');
    var labels = inventoryLabels(item);

    gridItem.className = 'grid__item grid-product small--one-half medium-up--one-fifth';
    gridItem.dataset.multilikesWishlistItem = String(item.id || '');
    content.className = 'grid-product__content';
    link.className = 'grid-product__link';
    link.href = productUrl(item);
    imageMask.className = 'grid-product__image-mask';
    imageRatio.className = 'grid__image-ratio grid__image-ratio--square';

    if (item.image) {
      var image = document.createElement('img');
      image.className = 'grid-product__image lazyloaded';
      image.src = item.image;
      image.alt = item.title || '';
      image.loading = 'lazy';
      imageRatio.appendChild(image);
    }

    if (labels.length) {
      var labelList = document.createElement('div');
      labelList.className = 'multilikes-wishlist__labels';
      labels.forEach(function(label) {
        var labelElement = document.createElement('div');
        labelElement.className = 'grid-product__tag ' + label.className;
        labelElement.textContent = label.text;
        labelList.appendChild(labelElement);
      });
      content.appendChild(labelList);
    }

    content.appendChild(createWishlistButton(item));
    imageMask.appendChild(imageRatio);
    link.appendChild(imageMask);

    meta.className = 'grid-product__meta';
    title.className = 'grid-product__title grid-product__title--' + (config.productTitleStyle || 'body');
    title.textContent = item.title || '';
    meta.appendChild(title);

    if (item.variantTitle) {
      variantTitle.className = 'grid-product__vendor';
      variantTitle.textContent = item.variantTitle;
      meta.appendChild(variantTitle);
    }

    price.className = 'grid-product__price';
    if (item.compareAtPrice) {
      var comparePrice = document.createElement('span');
      comparePrice.className = 'grid-product__price--original';
      comparePrice.textContent = item.compareAtPrice;
      price.appendChild(comparePrice);
    }
    price.appendChild(document.createTextNode((item.compareAtPrice ? ' ' : '') + (item.price || '')));
    meta.appendChild(price);
    link.appendChild(meta);
    content.appendChild(link);
    gridItem.appendChild(content);
    return gridItem;
  }

  function Wishlist(root) {
    this.root = root;
    this.customerId = root.dataset.customerId;
    this.limit = Number(root.dataset.limit || 24);
    this.items = [];
    this.total = 0;
    this.isLoading = false;
    this.filters = {
      playerName: new Set(),
      size: new Set(),
      productType: new Set()
    };
    this.priceRanges = new Set();
    this.grid = root.querySelector('[data-multilikes-grid]');
    this.sort = root.querySelector('[data-multilikes-sort]');
    this.count = root.querySelector('[data-multilikes-count]');
    this.loadingMessage = root.querySelector('[data-multilikes-loading]');
    this.emptyMessage = root.querySelector('[data-multilikes-empty]');
    this.noResultsMessage = root.querySelector('[data-multilikes-no-results]');
    this.errorMessage = root.querySelector('[data-multilikes-error]');
    this.bindEvents();
    this.load();
  }

  Wishlist.prototype.bindEvents = function() {
    this.root.addEventListener('change', function(event) {
      var filterInput = event.target.closest('[data-multilikes-filter]');
      if (filterInput) {
        var dimension = filterInput.dataset.multilikesFilter;
        var selectedValues = this.filters[dimension];
        if (filterInput.checked) {
          selectedValues.add(filterInput.value);
        } else {
          selectedValues.delete(filterInput.value);
        }
        this.syncFilterInputs(dimension);
        this.render();
        return;
      }

      if (event.target.matches('[data-multilikes-price-range]')) {
        if (event.target.checked) {
          this.priceRanges.add(event.target.value);
        } else {
          this.priceRanges.delete(event.target.value);
        }
        this.syncPriceRangeInputs();
        this.render();
        return;
      }

      if (event.target.matches('[data-multilikes-sort]')) {
        this.render();
      }
    }.bind(this));

    if (window.theme && theme.collapsibles) {
      theme.collapsibles.init(this.root);
    }
    if (window.theme && theme.Drawers && document.getElementById('MultiLikesFilterDrawer')) {
      this.filterDrawer = new theme.Drawers('MultiLikesFilterDrawer', 'multilikes-filters');
    }

    document.addEventListener('multilikes:changed', function(event) {
      if (!event.detail.isInWishlist) {
        var previousLength = this.items.length;
        this.items = this.items.filter(function(item) {
          return String(item.id) !== String(event.detail.variantId);
        });
        if (this.items.length !== previousLength) {
          this.total = Math.max(0, this.total - 1);
          this.render();
        }
      }
    }.bind(this));
  };

  Wishlist.prototype.load = function() {
    if (this.isLoading || !this.customerId) {
      return;
    }

    this.isLoading = true;
    this.loadingMessage.classList.remove('hide');
    this.errorMessage.classList.add('hide');

    this.loadPage(null, new Set())
      .then(this.render.bind(this))
      .catch(function(error) {
        console.error(error);
        this.errorMessage.classList.remove('hide');
      }.bind(this))
      .finally(function() {
        this.isLoading = false;
        this.loadingMessage.classList.add('hide');
      }.bind(this));
  };

  Wishlist.prototype.loadPage = function(after, loadedCursors) {
    return api.getCustomerWishlist(this.customerId, this.limit, after)
      .then(function(payload) {
        var newItems = Array.isArray(payload.data) ? payload.data : [];
        var startIndex = this.items.length;
        return Promise.all(newItems.map(enrichProductData)).then(function(items) {
          items.forEach(function(item, index) {
            item.registrationOrder = startIndex + index;
          });
          this.items = this.items.concat(items);
          this.total = Number(payload.total || this.items.length);

          var pageInfo = payload.pageInfo || {};
          var nextCursor = pageInfo.endCursor || null;
          if (!pageInfo.hasNextPage || !nextCursor || loadedCursors.has(nextCursor)) {
            return;
          }
          loadedCursors.add(nextCursor);
          return this.loadPage(nextCursor, loadedCursors);
        }.bind(this));
      }.bind(this));
  };

  Wishlist.prototype.filteredItems = function() {
    return this.items.filter(function(item) {
      var matchesDimensions = Object.keys(this.filters).every(function(dimension) {
        var selectedValues = this.filters[dimension];
        return selectedValues.size === 0 || selectedValues.has(String(item[dimension] || ''));
      }.bind(this));
      if (!matchesDimensions) {
        return false;
      }

      var price = Number(item.priceAmount || 0);
      return this.matchesPriceRanges(price);
    }.bind(this));
  };

  Wishlist.prototype.matchesPriceRanges = function(price) {
    if (this.priceRanges.size === 0) {
      return true;
    }

    return Array.from(this.priceRanges).some(function(rangeKey) {
      var range = wishlistPriceRanges[rangeKey];
      if (!range) {
        return false;
      }
      return (range.min === null || price >= range.min) && (range.max === null || price <= range.max);
    });
  };

  Wishlist.prototype.sortedItems = function(items) {
    var sortValue = this.sort.value;
    return items.slice().sort(function(a, b) {
      if (sortValue === 'registration-asc') {
        return b.registrationOrder - a.registrationOrder;
      }
      if (sortValue === 'price-desc') {
        return b.priceAmount - a.priceAmount || a.registrationOrder - b.registrationOrder;
      }
      if (sortValue === 'price-asc') {
        return a.priceAmount - b.priceAmount || a.registrationOrder - b.registrationOrder;
      }
      return a.registrationOrder - b.registrationOrder;
    });
  };

  Wishlist.prototype.filterValues = function(dimension) {
    return this.items.map(function(item) {
      return String(item[dimension] || '').trim();
    }).filter(Boolean).filter(function(value, index, values) {
      return values.indexOf(value) === index;
    }).sort(function(a, b) {
      return a.localeCompare(b, 'ja', { numeric: true, sensitivity: 'base' });
    });
  };

  Wishlist.prototype.updateFilterOptions = function() {
    Object.keys(this.filters).forEach(function(dimension) {
      var values = this.filterValues(dimension);
      var selectedValues = this.filters[dimension];
      Array.from(selectedValues).forEach(function(value) {
        if (values.indexOf(value) === -1) {
          selectedValues.delete(value);
        }
      });

      this.root.querySelectorAll('[data-multilikes-filter-options="' + dimension + '"]').forEach(function(list, listIndex) {
        var group = list.closest('[data-multilikes-filter-group]');
        group.classList.toggle('hide', values.length === 0);
        list.innerHTML = '';
        values.forEach(function(value, valueIndex) {
          var count = this.items.filter(function(item) {
            return String(item[dimension] || '') === value;
          }).length;
          var row = document.createElement('li');
          var label = document.createElement('label');
          var input = document.createElement('input');
          var checkbox = document.createElement('span');
          var text = document.createElement('span');

          row.className = 'tag' + (selectedValues.has(value) ? ' tag--active' : '');
          label.className = 'tag__checkbox-wrapper text-label';
          input.type = 'checkbox';
          input.className = 'tag__input';
          input.value = value;
          input.checked = selectedValues.has(value);
          input.dataset.multilikesFilter = dimension;
          input.id = 'MultiLikes-' + dimension + '-' + listIndex + '-' + valueIndex;
          checkbox.className = 'tag__checkbox';
          text.innerHTML = '<span class="tag__text"></span> (' + count + ')';
          text.querySelector('.tag__text').textContent = value;

          label.htmlFor = input.id;
          label.appendChild(input);
          label.appendChild(checkbox);
          label.appendChild(text);
          row.appendChild(label);
          list.appendChild(row);
        }.bind(this));
      }.bind(this));
    }.bind(this));

    this.root.querySelectorAll('[data-multilikes-price-range-count]').forEach(function(element) {
      var rangeKey = element.dataset.multilikesPriceRangeCount;
      var count = this.items.filter(function(item) {
        var range = wishlistPriceRanges[rangeKey];
        var price = Number(item.priceAmount || 0);
        return range && (range.min === null || price >= range.min) && (range.max === null || price <= range.max);
      }).length;
      element.textContent = ' (' + count + ')';
    }.bind(this));
  };

  Wishlist.prototype.syncFilterInputs = function(dimension) {
    var selectedValues = this.filters[dimension];
    this.root.querySelectorAll('[data-multilikes-filter="' + dimension + '"]').forEach(function(input) {
      input.checked = selectedValues.has(input.value);
      input.closest('.tag').classList.toggle('tag--active', input.checked);
    });
  };

  Wishlist.prototype.syncPriceRangeInputs = function() {
    this.root.querySelectorAll('[data-multilikes-price-range]').forEach(function(input) {
      input.checked = this.priceRanges.has(input.value);
      input.closest('.tag').classList.toggle('tag--active', input.checked);
    }.bind(this));
  };

  Wishlist.prototype.activeFilterCount = function() {
    return Object.keys(this.filters).reduce(function(total, dimension) {
      return total + this.filters[dimension].size;
    }.bind(this), this.priceRanges.size);
  };

  Wishlist.prototype.render = function() {
    this.updateFilterOptions();
    var items = this.sortedItems(this.filteredItems());
    var fragment = document.createDocumentFragment();
    this.grid.innerHTML = '';

    items.forEach(function(item) {
      fragment.appendChild(createWishlistCard(item));
    });
    this.grid.appendChild(fragment);

    this.count.textContent = items.length + ' / ' + this.total;
    this.emptyMessage.classList.toggle('hide', this.items.length !== 0);
    this.noResultsMessage.classList.toggle('hide', this.items.length === 0 || items.length !== 0);
    var activeFilterCount = this.activeFilterCount();
    this.root.querySelectorAll('[data-multilikes-filter-count]').forEach(function(element) {
      element.textContent = '(' + activeFilterCount + ')';
      element.classList.toggle('hide', activeFilterCount === 0);
    });
  };

  function init() {
    initializeLoginModal();
    initializeVariantModal();
    applyAllButtonStates(document);
    document.querySelectorAll('[data-multilikes-wishlist]').forEach(function(root) {
      new Wishlist(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MultiLikes = {
    api: api,
    init: applyAllButtonStates
  };
})();
